import React from 'react';

class ScrollDownButton extends React.Component {
  scrollDown = () => {
    const section = document.getElementById('sectionToScrollTo');
    section.scrollIntoView({ behavior: 'smooth' });
  };

  render() {
    return (
      

      <button onClick={this.scrollDown} class="bg-white hover:bg-gray-200 text-black font-bold py-2 px-4 rounded">
      Let's Go!!
    </button>
      
      
    );
  }
}

export default ScrollDownButton;
